export const navLinks = [
  { label: '홈', href: '#hero' },
  { label: '단지소개', href: '#about' },
  { label: '입지프리미엄', href: '#community' },
  { label: '세대정보', href: '#units' },
  { label: '분양안내', href: '#pricing' },
  { label: '방문예약', href: '#reservation' },
];

export const contactPhone = '1555-1554';
export const projectName = '신상도역 이안';
export const projectFullName = 'APT 신상도역';
export const trustCompany = '무궁화신탁(주)';
export const trustCompanyEn = 'MUGUNGHWA TRUSTCO.,LTD';
export const bankInfo = '국민은행 437637-01-016860';
export const contractAccount = '012501-04-366755';
export const totalUnits = '총 459세대';
export const projectType = '장기일반민간임대주택';
export const projectLocation = '서울특별시 동작구 상도동';

export const communityFacilities = [
  {
    title: '신상도역 초역세권',
    subtitle: '교통 및 여가 녹지 접근성 양호, 중심지 및 양호한 녹지와 연계된 주거지 잠재력이 높은 프리미엄 입지',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20subway%20station%20entrance%20with%20clean%20contemporary%20architecture%2C%20bright%20daylight%2C%20urban%20landscape%20with%20pedestrians%2C%20city%20infrastructure%2C%20warm%20natural%20lighting%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=800&seq=location-subway-01&orientation=squarish',
  },
  {
    title: '상도동 미니신도시',
    subtitle: '상도 14\u00b715구역(4,323세대)과 모아타운(1,534세대)으로 약 5,900세대 규모의 미니신도시로 탈바꿈 예정',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20redevelopment%20district%20aerial%20view%20in%20Seoul%2C%20new%20apartment%20towers%20under%20construction%2C%20clean%20wide%20streets%2C%20green%20public%20spaces%2C%20contemporary%20city%20planning%2C%20bright%20daylight%2C%20architectural%20photography%2C%20warm%20neutral%20tones&width=800&height=800&seq=location-develop-01&orientation=squarish',
  },
  {
    title: 'HUG 전세자금대출 80%',
    subtitle: 'HUG 전세자금대출 80% 지원으로 계약금 10%만으로 입주 가능, 10년 거주 후 소유권 이전',
    image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20consulting%20office%20interior%20with%20clean%20minimal%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20comfortable%20meeting%20space%2C%20neutral%20cream%20and%20wood%20tones%2C%20editorial%20photography%20style%2C%20high%20detail&width=800&height=800&seq=location-finance-01&orientation=squarish',
  },
];

export const unitTypes = [
  {
    name: '59㎡',
    area: '59㎡ (24평형)',
    price: '6.45억 ~ 6.99억',
    label: 'BEST',
    rooms: '2Room',
    supply: '315세대',
    image: 'https://readdy.ai/api/search-image?query=Modern%20compact%20Korean%20apartment%20interior%20living%20room%2C%2024%20pyeong%20size%20with%20efficient%20layout%2C%20bright%20natural%20light%20streaming%20through%20large%20windows%2C%20minimalist%20warm%20furniture%2C%20neutral%20cream%20tones%2C%20clean%20editorial%20real%20estate%20photography%2C%20Seoul%20residential%20style&width=600&height=500&seq=unit-59-real-01&orientation=landscape',
  },
  {
    name: '71㎡',
    area: '71㎡ (28평형)',
    price: '7.34억 ~ 7.99억',
    label: null,
    rooms: '3Room',
    supply: '37세대',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20apartment%20interior%20bedroom%20and%20living%20area%2C%2028%20pyeong%20spacious%20layout%2C%20warm%20oak%20wood%20flooring%2C%20elegant%20contemporary%20design%2C%20bright%20natural%20lighting%20from%20floor%20to%20ceiling%20windows%2C%20editorial%20real%20estate%20photography%2C%20Seoul%20apartment%20style&width=600&height=500&seq=unit-71-real-01&orientation=landscape',
  },
  {
    name: '84㎡',
    area: '84㎡ (33평형)',
    price: '8.43억 ~ 9.11억',
    label: 'PREMIUM',
    rooms: '3Room',
    supply: '107세대',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20Korean%20apartment%20interior%20open%20plan%20living%20dining%20space%2C%2033%20pyeong%20size%20with%20premium%20finishes%2C%20bright%20and%20airy%20atmosphere%2C%20modern%20elegant%20furniture%2C%20warm%20neutral%20tones%2C%20high%20ceilings%2C%20editorial%20real%20estate%20photography%2C%20Seoul%20premium%20residential%20style&width=600&height=500&seq=unit-84-real-01&orientation=landscape',
  },
];

export const testimonials = [
  {
    quote: '장기일반민간임대주택은 입주희망자가 입주목적의 임의단체를 결성하고 회원으로 가입, 초기사업비에 대해 회원으로 투자하여 임대아파트를 우선 분양받습니다. 10년 거주 후 소유권 이전이 가능한 안정적인 주거 방식으로, 서울 초역세권에서 내 집 마련의 기회를 제공합니다.',
    name: '장기일반민간임대주택',
    role: '10년 거주 후 소유권 이전',
    image: 'https://readdy.ai/api/search-image?query=Modern%20high-rise%20apartment%20building%20exterior%20at%20golden%20hour%20with%20warm%20sunlight%2C%20clean%20contemporary%20architecture%2C%20landscaped%20podium%20gardens%2C%20home%20ownership%20concept%2C%20editorial%20real%20estate%20photography%2C%20bright%20warm%20atmosphere%2C%20Seoul%20residential%20tower&width=400&height=600&seq=benefit-01-real-01&orientation=portrait',
  },
  {
    quote: 'HUG 전세자금대출 80% 지원으로 초기 부담을 크게 줄일 수 있습니다. 계약금 10%만 납부하고 입주 가능하며, 10년간 임대보증금 형태로 거주하다가 소유권을 취득할 수 있습니다. 서울 동작구 신상도역 초역세권 아파트의 희귀한 기회를 놓치지 마세요.',
    name: 'HUG 전세자금대출 80% 지원',
    role: '계약금 10%로 입주 가능',
    image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20security%20and%20housing%20support%20concept%2C%20clean%20minimal%20composition%20with%20house%20key%20and%20shield%20symbol%2C%20warm%20professional%20lighting%2C%20home%20loan%20support%20concept%2C%20editorial%20photography%20style%2C%20neutral%20cream%20and%20gold%20tones%2C%20high%20detail&width=400&height=600&seq=benefit-02-real-01&orientation=portrait',
  },
];

export const pricingData = [
  {
    type: '59㎡ (24평형)',
    supply: '315세대',
    depositRange: '645,000 ~ 699,000',
    salePriceRange: '806,250 ~ 873,750',
    hugLoan: '516,000 ~ 559,200',
    contractFee: '35,000',
    floorGroups: ['가군(1층)', '나군(2~5층)', '다군(6~12층)', '라군(13~19층)', '마군(20~29층)', '바군(30~37층)'],
  },
  {
    type: '71㎡ (28평형)',
    supply: '37세대',
    depositRange: '733,700 ~ 799,240',
    salePriceRange: '917,125 ~ 999,050',
    hugLoan: '586,960 ~ 639,392',
    contractFee: '35,000',
    floorGroups: ['가군(1층)', '나군(2~5층)', '다군(6~12층)', '라군(13~19층)', '마군(20~29층)', '바군(30~37층)'],
  },
  {
    type: '84㎡ (33평형)',
    supply: '107세대',
    depositRange: '843,200 ~ 911,200',
    salePriceRange: '1,054,000 ~ 1,139,000',
    hugLoan: '674,560 ~ 728,960',
    contractFee: '35,000',
    floorGroups: ['가군(1층)', '나군(2~5층)', '다군(6~12층)', '라군(13~19층)', '마군(20~29층)', '바군(30~37층)'],
  },
];

export const paymentSchedule = [
  { step: '계약금', timing: '계약시', rate: '10%', note: '정액제' },
  { step: '1차 중도금', timing: '계약후 50일이내', rate: '-', note: '정액제' },
  { step: '2차 중도금', timing: '입주지정일', rate: '-', note: '정액제' },
  { step: '잔금', timing: '10년 후 소유권 이전시', rate: '잔액', note: '소유권 이전' },
];

export const heroBackgroundImage = 'https://readdy.ai/api/search-image?query=Modern%20luxury%20high-rise%20apartment%20complex%20exterior%20at%20golden%20hour%2C%20Seoul%20cityscape%20background%20with%20mountains%2C%20clean%20contemporary%20architectural%20lines%2C%20blue%20sky%20with%20soft%20clouds%2C%20editorial%20photography%20style%2C%20bright%20and%20airy%20atmosphere%2C%20high-end%20residential%20tower%2C%20warm%20sunlight%2C%20landscaped%20podium%20gardens&width=1920&height=1080&seq=hero-bg-sinsangdo-01&orientation=landscape';

export const reservationBgImage = 'https://storage.readdy-site.link/project_files/5de00db6-0430-441c-b10d-847a16bb9b2c/e7d055f9-ab3d-44f7-9b8a-254a5308a19d_compressed_-.webp';